import { isEmpty } from 'lodash';
import React, { useEffect, useState } from 'react';
import { Text } from 'src/@vymo/ui/atoms';
import { Card, SegmentedTabs, Table } from 'src/@vymo/ui/blocks';
import SkeletonLoader from 'src/@vymo/ui/blocks/skelton';
import { Keys, locale } from 'src/i18n';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import ErrorState from '../../components/errorState';
import { keyMetricDetailsNavigation } from '../../queries';
import {
  getKeyMetricsDetails,
  getKeyMetricsTeamBreakdown,
  getStatus,
} from '../../selector';
import { fetchKeyMetricsDetails } from '../thunk';
import styles from '../index.module.scss';

function TeamBreakdown() {
  const dispatch = useAppDispatch();
  const status = useAppSelector((state) =>
    getStatus(state, 'key_metrics_team_breakdown'),
  );
  const teamBreakdown = useAppSelector(getKeyMetricsTeamBreakdown);
  const details = useAppSelector(getKeyMetricsDetails);
  const [filters, setFilters] = useState<Record<string, any>>({});

  const teamBreakdownFilters = details?.result?.grouped_record_filters || [];

  useEffect(() => {
    if (!isEmpty(filters)) {
      dispatch(
        fetchKeyMetricsDetails({
          id: details?.result?.metric?.goal_definition_code,
          card: details?.card,
          filters,
          userId: details?.result?.drilldown_meta?.user_id,
        }),
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters]);

  const onFiltersChange = (key, value) => {
    setFilters((prevFilters) => ({ ...prevFilters, [key]: value }));
  };

  const teamBreakdownRowClick = (r) => {
    const row = r?.body?.result;
    if (!row.subordinatesCount) return;
    const nextId = row?.metric?.goal_definition_code;
    if (!nextId) return;
    const params = {
      frequency: details?.card?.frequency ?? '',
      start_date:
        details?.card?.date_range?.start ?? details?.card?.start_date ?? '',
      userId: row?.drilldown_meta?.user_id,
      title: row?.group_by_key?.name ?? '',
      subordinatesCount: row?.subordinatesCount,
    };
    keyMetricDetailsNavigation({ params, code: nextId, dispatch });
  };

  return (
    <Card classNames={styles.details__teamBreakdown}>
      <Text type="h5">{locale(Keys.TEAM_BREAKDOWN)}</Text>
      {status === 'loading' && <SkeletonLoader lines={8} />}
      {status === 'error' && <ErrorState />}
      {status === 'done' && (
        <>
          <div className={styles.details__teamBreakdown__filters}>
            {teamBreakdownFilters.map((inp) => {
              switch (inp.type) {
                case 'code_name_spinner':
                  if (!inp.code_name_spinner_options?.length) return null;
                  if (inp.visualization === 'chip')
                    return (
                      <SegmentedTabs
                        tabs={inp.code_name_spinner_options
                          .filter((option) => Boolean(option.name))
                          .map((option) => ({
                            label: option.name,
                            key: option.code,
                          }))}
                        activeTabKey={filters?.[inp.code] || inp.value}
                        onTabChange={(key) => onFiltersChange(inp.code, key)}
                        tabItemClassName={
                          styles.details__teamBreakdown__filters__segmentedTab
                        }
                      />
                    );

                  return null;

                default:
                  return null;
              }
            })}
          </div>

          <Table
            tableData={teamBreakdown?.data || []}
            columnConfigs={teamBreakdown?.columns || []}
            isAccordion={false}
            tableConfig={{
              name: '',
              hideColumnConfigurator: true,
              onRowClick: (_, r) => teamBreakdownRowClick(r),
            }}
          />
        </>
      )}
    </Card>
  );
}

export default TeamBreakdown;
